import { call, put, select } from 'redux-saga/effects';
import { API } from '../../api';

const getServerConfig = ({ serverConfig }) => serverConfig;

export function* createSurveyAccount(action) {
  const serverConfig = yield select(getServerConfig);
  const { account, survey } = action.payload;

  try {
    const path = `/survey/${serverConfig.namespace}/${survey.id}/users`;

    const result = yield call(API, 'post', 'api', path, {
      body: {
        emails: account.email,
      },
    });

    yield put({
      type: 'ADD_SURVEY_ACCOUNTS',
      payload: {
        surveyId: survey.id,
        accounts: result.accounts,
      },
    });

    return result;
  } catch (e) {
    console.error(e);
  }
  return null;
}
